import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=30080b94&"
import script from "./Badge.vue?vue&type=script&setup=true&lang=js&"
export * from "./Badge.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Badge.vue?vue&type=style&index=0&id=30080b94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports